import {
  Button,
  Col,
  Divider,
  Flex,
  Form,
  Grid,
  Input,
  Row,
  Typography,
} from "antd";
import style from "./Login.module.css";
import Footer from "../../components/v2/Footer/Footer";
import bevzLogo from "../../assets/v2/bevzLogo.png";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  checkAuth,
  login,
} from "../../components/apiRepository/DynamodbRepository";
import {
  ACTIONTYPES,
  useStoreDispatch,
} from "../../context/CreateStoreContext";

const { Text, Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

export default function Login() {
  const dispatch = useStoreDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const clearErrorMsg = () => setError(null);
  const screen = useBreakpoint();

  const onFinish = async (values) => {
    setLoading(true);
    setError(null);
    try {
      const token = await login(values);
      const storeDetails = await checkAuth({ token }).then(({ data }) => data);
      setLoading(false);

      dispatch({
        type: ACTIONTYPES.LOGINDETAILS,
        data: { token, storeDetails },
      });
      navigate("/dashboard", { replace: true });
      return;
    } catch (error) {
      setLoading(false);
      const errmsg = error?.response?.data?.errors[0];
      if (errmsg === "User does not exist") {
        setError("Email or password is incorrect. Please try again.");
      } else {
        setError(
          error?.response?.data?.errors[0] || error?.message || "Login failed.",
        );
      }
    }
  };

  return (
    <>
      <Row style={{ minHeight: "calc(100vh - 32px)" }}>
        <Col
          xs={{ span: 22, offset: 1 }}
          lg={{ span: 9, offset: 0 }}
          className={style.Left}
        >
          <Row align={{ sm: "middle", lg: "top" }} style={{ height: "100%" }}>
            <Col
              xs={{ span: 24, offset: 0 }}
              md={{ span: 15, offset: 1 }}
              lg={{ span: 15, offset: 2 }}
              xl={{ offset: 6 }}
              style={{ padding: screen.xs ? "30px 20px" : "unset" }}
            >
              <Title
                level={screen.xs ? 3 : 2}
                style={{
                  margin: 0,
                  color: "#1c2e5c",
                  lineHeight: 1,
                  textAlign: screen.xs ? "center" : "start",
                }}
              >
                Powering your snack & drink delivery business
                <Text style={{ color: "#f7ca0f", fontSize: "inherit" }}>.</Text>
              </Title>
              <Paragraph
                style={{
                  margin: 0,
                  textAlign: screen.xs ? "center" : "start",
                  fontSize: screen.xs ? "inherit" : "16px",
                }}
              >
                We simplify your delivery business by providing access to top
                delivery apps from one user-friendly platform.
              </Paragraph>
            </Col>
          </Row>
        </Col>
        <Col xs={24} lg={15}>
          <Row style={{ height: "100%" }}>
            <Col
              xs={{ span: 18, offset: 3 }}
              lg={{ span: 12, offset: 4 }}
              xl={{ span: 8, offset: 4 }}
            >
              <Flex
                vertical
                align="center"
                justify="space-between"
                style={{ height: "100%", width: "100%" }}
              >
                <Flex
                  align="center"
                  justify="center"
                  vertical
                  flex={1}
                  style={{
                    paddingTop: screen.xs ? "2.5rem" : "6.25rem",
                    width: "100%",
                  }}
                >
                  <img
                    src={bevzLogo}
                    width="171px"
                    height="115px"
                    className="BevzLogo"
                  />
                  <Title
                    level={screen.xs ? 3 : 2}
                    style={{
                      color: "#242424",
                      marginTop: screen.xs ? "1rem" : "1.25rem",
                      marginBottom: screen.xs ? "0.25rem" : "0.5rem",
                    }}
                  >
                    Welcome Back
                  </Title>
                  <Paragraph
                    style={{
                      textAlign: "center",
                      color: "#515151",
                      lineHeight: "1.1",
                      marginBottom: screen.xs ? "1.875rem" : "3.125rem",
                    }}
                  >
                    Log in to your account and manage your stores.
                  </Paragraph>
                  <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                    className={style.form}
                    requiredMark={false}
                    style={{ width: "100%" }}
                  >
                    <Form.Item
                      name="email"
                      label="Email Address"
                      required
                      rules={[
                        {
                          required: true,
                          message: "This is a required field.",
                        },
                      ]}
                    >
                      <Input
                        placeholder="your@email.com"
                        size="large"
                        onChange={clearErrorMsg}
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      label="Password"
                      required
                      rules={[
                        {
                          required: true,
                          message: "This is a required field.",
                        },
                      ]}
                      style={{ marginBottom: 0 }}
                    >
                      <Input.Password
                        placeholder=""
                        size="large"
                        onChange={clearErrorMsg}
                      />
                    </Form.Item>

                    <div className={style.forgot_password}>
                      <Link to="/forgotpassword">Forgot password?</Link>
                    </div>
                    <div style={{ textAlign: "center", minHeight: "22px" }}>
                      {error ? (
                        <Text type="danger" strong>
                          {error}
                        </Text>
                      ) : null}
                    </div>

                    <Form.Item style={{ marginBottom: 0 }}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className={style.login_form_button}
                        iconPosition="end"
                        loading={loading}
                      >
                        Log in
                      </Button>
                    </Form.Item>
                  </Form>

                  <Divider
                    plain
                    style={{ marginTop: "2.5rem", marginBottom: "2.5rem" }}
                  >
                    or
                  </Divider>

                  <Paragraph
                    style={{ margin: 0, color: "#3d3d3d", textAlign: "center" }}
                  >
                    Are you new to Bevz?
                    <br />
                    <Link to="/" relative="path" style={{ fontWeight: "600" }}>
                      Get Started and Create your first store
                    </Link>
                  </Paragraph>
                </Flex>

                <Paragraph className={style.ContactUs}>
                  For any questions, contact us at{" "}
                  <a href="mailto:support@bevz.com">support@bevz.com</a>
                </Paragraph>
              </Flex>
            </Col>
          </Row>
        </Col>
      </Row>

      <Footer />
    </>
  );
}
